import { AnimatePresence, motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase'
import { filterFixtures, findPlayer } from '../../../../helpers/fixturesHelper'
import ScrollView from '../../../ScrollView/ScrollView'
import UtenlandsProffScrollListtemplate from './UtenlandsProffScrollListTemplate'

function UtenlandsProfferScrollTemplate({ allFixtures, type }) {
    const [proffer, setProffer] = useState([])

    const [fixtures, setFixtures] = useState([])
    const [show, setShow] = useState(true)

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    useEffect(() => {
        try {
            const proffRef = firestore.collection('utenlandsproffer')
            proffRef.onSnapshot(({ docs }) => {
                const proffer = docs.map((doc) => {
                    return { id: doc.id, ...doc.data() }
                })
                setProffer(proffer)
            })
        } catch (error) {}
    }, [])

    useEffect(() => {
        if (proffer) {
            const teamIds = proffer.map((proff) => {
                return proff.team_id
            })

            const fixtures = filterFixtures(allFixtures, teamIds)
            setFixtures(fixtures)
        }
    }, [proffer, allFixtures])

    // players have team_id, compare with live fixtures team ids

    return (
        <div>
            <ScrollView items={fixtures} proffer={proffer} type="player" />
            <div
                className="card card-header bg-lightgrey"
                style={{ cursor: 'pointer' }}
                onClick={toggle}
            >
                <div>
                    <small>
                        <img
                            src="https://media.api-sports.io/flags/no.svg"
                            alt=""
                            className="img-fluid"
                            style={{ maxWidth: '16px', borderRadius: '20%' }}
                        />
                        <span> Norske spillere</span>
                        <span className="float-right">
                            <i
                                className={`fas fa-chevron-${
                                    show ? 'up' : 'down'
                                }`}
                            ></i>
                        </span>
                    </small>
                </div>
            </div>
            {show && (
                <AnimatePresence>
                    <motion.div
                        className="category"
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { opacity: 1, height: 'auto' },
                            collapsed: { opacity: 0, height: 0 },
                        }}
                        transition={{
                            duration: 0.8,
                            ease: [0.04, 0.62, 0.23, 0.98],
                        }}
                    >
                        {fixtures?.map((fixture, index) => {
                            const playersFixture = findPlayer(
                                fixture.homeTeam.team_id,
                                fixture.awayTeam.team_id,
                                proffer
                            )

                            return (
                                <UtenlandsProffScrollListtemplate
                                    fixture={fixture}
                                    key={index}
                                    playersFixture={playersFixture}
                                    type={type}
                                />
                            )
                        })}
                    </motion.div>
                </AnimatePresence>
            )}
        </div>
    )
}
export default UtenlandsProfferScrollTemplate
